import { formView as formViewEvent } from '@wix/bi-logger-forms-platform-uou/v2';
import { Form, FormStatusProvider, useBi } from '@wix/form-fields';
import React, { useCallback, useEffect } from 'react';
import { useForm } from '../../hooks/use-form';
import { reportErrorChanges } from '../../hooks/use-validation';
import { DATA_HOOKS } from '../../tpa/widget/data-hooks';
import { SubmitStatusMessage } from '../submit-status-message/submit-status-message';
import { StepTitleA11y } from './step-title-a11y';
export const FormRoot = ({ form: unprocessedForm, values: unprocessedValues, stepId, onStepIdChange, onChange, onBlur, onFocus, errors, onValidate, onSubmit, onSubmitSuccess, onSubmitFailure, forwardedRef, readOnly, overrides, actions, inProgress, userData, addressTemplates, breakpoint, onStatusChange, validationMode, fields, enableAutofill, onSubmissionLimitReached })=>{
    const bi = useBi();
    const _onValidate = useCallback((newErrors)=>{
        reportErrorChanges({
            bi,
            existingErrors: errors,
            newErrors,
            form: unprocessedForm
        });
        onValidate(newErrors);
    }, [
        bi,
        errors,
        onValidate,
        unprocessedForm
    ]);
    const { formWithOverrides, normalizedValues, onFieldChange, currentStep, fieldActions, handleFieldValidation, currentView, formViews } = useForm({
        form: unprocessedForm,
        values: unprocessedValues,
        stepId,
        onStepIdChange,
        onChange,
        onBlur,
        onFocus,
        errors,
        onValidate: _onValidate,
        onSubmit,
        onSubmitSuccess,
        onSubmitFailure,
        fieldMap: fields,
        userData,
        addressTemplates,
        overrides,
        actions,
        inProgress,
        breakpoint,
        validationMode,
        forwardedRef,
        enableAutofill,
        onSubmissionLimitReached
    });
    useEffect(()=>{
        bi.report(formViewEvent({
            mode: readOnly ? 'preview' : 'live_site'
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!formViews?.length || !currentView) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FormStatusProvider, {
        onStatusChange: onStatusChange
    }, /*#__PURE__*/ React.createElement("div", {
        "data-hook": DATA_HOOKS.FORM_ROOT
    }, /*#__PURE__*/ React.createElement(Form, {
        formSchema: formWithOverrides,
        form: currentView,
        values: normalizedValues,
        onFieldChange: onFieldChange,
        onBlur: onBlur,
        onFocus: onFocus,
        errors: errors,
        dataHook: DATA_HOOKS.FORM_ROOT,
        validateFields: handleFieldValidation,
        fields: fields,
        fieldActions: fieldActions
    }), /*#__PURE__*/ React.createElement(StepTitleA11y, {
        total: formWithOverrides.steps?.length,
        index: currentStep
    }), /*#__PURE__*/ React.createElement(SubmitStatusMessage, null)));
};

//# sourceMappingURL=form-root.js.map